module.exports = __webpack_public_path__ + "media/images/promo/dreamtime-36194f223a4b4773b908cff1b06d64d1c233e447d7f394679efcabd615a14135.jpeg";